import axios from "axios";
import { BACKEND_URL } from "../utils/constant";

const authHeader = (token) => ({
  headers: { authorization: `Bearer ${token}` },
});

const getAuths = async (token) => {
  const response = await axios.get(
    `${BACKEND_URL}api/auths`,
    authHeader(token)
  );
  return response;
};

const getAuth = async (token) => {
  const response = await axios.get(
    `${BACKEND_URL}api/auths/me`,
    authHeader(token)
  );
  return response;
};

const putAuth = async (token, data) => {
  const response = await axios.put(
    `${BACKEND_URL}api/auths`,
    data,
    authHeader(token)
  );
  return response;
};

const putAuthById = async (token, id, data) => {
  const response = await axios.put(
    `${BACKEND_URL}api/auths/${id}`,
    data,
    authHeader(token)
  );
  return response;
};

const postAuth = async (token, data) => {
  const response = await axios.post(
    `${BACKEND_URL}api/auths`,
    data,
    authHeader(token)
  );
  return response;
};

export default {
  getAuth,
  putAuth,
  putAuthById,
  getAuths,
  postAuth,
};
